module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/code/shift-f2e1134c58b5d37e6794bbedcd737b01.svg";